export const selectCounterPageContainer = (state) => state.containers.counterPageReducer;

// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectCount = (state) => {
  return selectCounterPageContainer(state).get('count');
};



// WEBPACK FOOTER //
// ./src/containers/CounterPage/selectors.js